import { ReactElement, useEffect, useState } from "react";
import { IChartWrapperProps } from "../../types";
import RadarChart from "../../../../components/charts/radarChart";
import { IRadarChartConfig } from "../../../../components/charts/types";
import { getGenericChartConfig } from "./utils";

const RadarChartWrapper = ({ cell, data, parentSize, palette, updatePalette, node, schemas }: IChartWrapperProps): ReactElement => {
  const [ chartConfig, setChartConfig ] = useState<IRadarChartConfig | null>(null);

  useEffect(() => {
    if (data) {
      const [ series, xAxis, yAxes ] = getGenericChartConfig(data, cell, node, palette, updatePalette, schemas);

      setChartConfig({
        height: parentSize.height,
        width: parentSize.width,
        series,
        yAxis: yAxes[0],
        xAxis,
        showLegend: true
      }
      );
    }
  }, [ cell, data, parentSize, palette, updatePalette, node, schemas ]);

  return (
    <div className="display-flex-row align-items-center justify-content-center"  style={{ ...parentSize }}>
      {chartConfig && <RadarChart radarConfig={chartConfig} selectedItem={null}/>}
    </div>
  );
};

export default RadarChartWrapper;
